"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeCanonicalizerAPI = void 0;
var _urlCanonicalizer = _interopRequireDefault(require("url-canonicalizer"));
var _UnknownPathError = require("./UnknownPathError");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
let initialized = false;
const makeCanonicalizerAPI = config => {
  if (initialized) {
    throw new Error("Canonicalizer API has already been initialized!");
  } else {
    _urlCanonicalizer.default.setConfig(config);
    initialized = true;
  }
  function urlToDataModel(url) {
    return new Promise((res, rej) => {
      _urlCanonicalizer.default.canonicalize(url, {}, (err, obj) => {
        if (err) {
          rej(err);
        } else if (!obj.found) {
          const validPaths = Object.values(config.paths).map(p => p.path);
          const error = new _UnknownPathError.UnknownPathError(url, validPaths);
          rej(error);
        } else {
          res(obj);
        }
      });
    });
  }
  function dataModelToQueryString(dataModel, querySet) {
    return _urlCanonicalizer.default.queryParamNormalizer.toQueryParams(dataModel, querySet, null).queryString;
  }
  return {
    urlToDataModel,
    dataModelToQueryString
  };
};
exports.makeCanonicalizerAPI = makeCanonicalizerAPI;